<div class="toro-component-shield-container" (click)="handleClick()" [ngClass]="{'click-enabled': this.shieldClick.observers.length > 0}">

</div>
